export type Event = {
  id: number;
  slug: string;
  name: string;
  startDate: string;
  currency: string;
  coverPhotoId: number;
  browsePhotosPath: string;
  price: number;
  displayPrice: string;
  overlayImageEnabled: boolean;
  overlayImageURL: string;
  overlayImagePosition: string;
  overlayImageSize: number;
  location: string;
  country: string;
  prepaidCustomersEnabled: boolean;
  isProtected: boolean;
  organiserEmail: string;
  organiserFirstName: string;
  prepaidCustomersHardLimitEnabled: boolean;
  prepaidCustomersPrimaryAuthField: string;
  prepaidCustomersSecondaryAuthField: string;
  isPrivate: boolean;
  albumsCount: number;
  discountStatusPath: any;
  hasDiscount: boolean;
  hidePhotographersFilter: boolean;
  hasPrintProducts: boolean;
  isPhotoIndexingDisabled: boolean;
  publishMode: string;
  canUpdatePrivacy: boolean;
  supportEmail: string;
  eventSupportLabel: string;
  date: string;
};

export type Album = {
  id: number;
  name: string;
  photosCount: number;
  photographerName: string;
  photographerEmail: string;
  signedId: string;
  links: {
    photos: string;
  };
  photographerId: number;
  eventId: number;
  eventName: string;
  event: Event;
};

export type Cart = {
  id: number;
  country: string;
  photos: number[];
  currency: string;
  prepaidPhotos: number[];
  photoBundleDiscountAvailed: boolean;
  photoBundleDiscountEventId: number;
  eventIds: number[];
  sales_count?: number;
};

export type Photo = {
  id: number;
  album: Album;
  timeTaken: number;
  dateTimeTaken: string;
  watermarkedImg: string;
  zoomImg: string;
  contentType: string;
  country: string;
  hidden: boolean;
  favorite: boolean;
  disableContextMenu: boolean;
  isSelected: boolean;
  src: string;
  thumbnail: string;
  thumbnailHeight: number;
  thumbnailWidth: number;
  videoContent: boolean;
  videoMuxId: string;
  videoMuxPlaybackId: string;
  event: Event;
  reportPhotoPath: string;
  hidePhotographersFilter: boolean;
  fileName: string;
};

export type PrepaidCustomer = {
  firstName: string;
  lastName: string;
  email: string;
  eventId: number;
  freePhotosAvailable: number;
};

export type Photographer = {
  name: string;
  id: number;
  albumsCount: number;
};

export type PageConfiguration = {
  showHeader: boolean;
  bannerUrl: string | null;
  croppedBannerURL: string | null;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
};

export type FilterSelections = {
  albums: Album[];
  photographers: Photographer[];
  photoTime: {
    minuteFrom: number;
    minuteTo: number;
    active: boolean;
  };
  referenceImage: string | null;
  photoText: string | null;
  favorite: boolean;
};

export enum ThumbnailSelectionMode {
  CART = "cart",
  CURATE = "curate",
  COVER = "cover"
}

declare global {
  interface Window {
    gss: {
      albumV2Enabled: boolean;
      isEmbedded: boolean;
      debug?: boolean;
    };
  }
}

export type PhotoGridProps = {
  items: Photo[];
  hasMoreItems: boolean;
  areMoreItemsLoading: boolean;
  loadMoreItems: () => void;
  numColumns?: number;
  width: number;
  otherProps: {
    event: any;
    isMobile?: boolean;
    thumbnailProps: {
      onClick: (photo: Photo) => void;
      onThumbnailSelect: (photo: Photo) => void;
      selectionMode: ThumbnailSelectionMode;
    };
    forceRender: boolean;
    onScrollDownStarted: () => void;
  };
};
